import React from 'react';
import impact from '../../assets/cfye-images/impact.svg';

export default function Story() {
  return (
    <section className="bg-[#212121] text-white flex flex-col items-center justify-center py-16 px-6 sm:px-10 lg:px-20">
      <div className="max-w-6xl w-full flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
        {/* Image */}
        <div className="w-full lg:w-1/2">
          <img
            src={impact}
            alt="Adedoyin Oyinkasola testimonial"
            className="w-full h-auto object-contain"
          />
        </div>

        {/* Text Content */}
        <div className="w-full lg:w-1/2">
          {/* Heading */}
          <h2 className=" mb-6 bg-dark-grey-1 py-1 px-2 rounded-full inline-block">
            Adedoyin Oyinkasola, CEO. Majinfotek
          </h2>

          {/* Description */}
          <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
            SHECLUDED transformed my mindset about building a business. The
            lectures and mentorship during the CYFE Dream to Business Cohort 2
            encouraged me to confidently face the marketing world and tackle
            business challenges as a small business owner. I feel truly
            inspired! Thank you, SHECLUDED!
          </p>
        </div>
      </div>
    </section>
  );
}
